export * from './useProductDetailsIngredientsTabs';
